import { Skeleton, Stack, Text } from '@sixui/ui';

import type { ITableRowProps } from '~/components/molecules/Table/TableRow';
import { UserAvatar } from '~/components/atoms/UserAvatar';
import { Table } from '~/components/molecules/Table';

export type IPollVoteListItemSkeletonProps = ITableRowProps;

export const PollVoteListItemSkeleton: React.FC<
  IPollVoteListItemSkeletonProps
> = (props) => {
  const { ...other } = props;

  return (
    <Table.Row {...other}>
      <Stack as={Table.Body} horizontal gap={3}>
        <Skeleton variant="circular">
          <UserAvatar />
        </Skeleton>
        <Stack gap={1}>
          <Text
            as={Skeleton}
            variant="title"
            size="sm"
            length={{ min: 8, max: 24 }}
          />
        </Stack>
      </Stack>
    </Table.Row>
  );
};
